// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"df3879fa","174":"eb5dccb0","223":"e783c15a","351":"8cd93ed5","466":"5d0fe364","544":"d47b5652"}[chunkId] + ".chunk.js";
};